export const SCHEDULES_PART03 = [
  {
    id: 'demo-sch-board-pack',
    title: 'Monthly board metrics pack',
    cron: '0 9 1 * *',
    enabled: true,
    apps: ['HubSpot', 'Google Sheets'],
    goal:
      'Pull last month’s bookings, pipeline coverage, win rate, and churn from HubSpot and the Finance sheet, and build a six-slide board update with charts and a short commentary on each metric.',
  },
  {
    id: 'demo-sch-release-notes',
    title: 'GitHub release notes',
    cron: '0 16 * * 4',
    enabled: false,
    apps: ['GitHub', 'Notion'],
    goal:
      'Collect pull requests merged into main since last Thursday, group them into features, fixes, and internal changes, and draft customer-facing release notes on the Notion Changelog page.',
  },
]
